// import i18n from "i18next";
// import { initReactI18next } from "react-i18next";

// i18n
//   .use(initReactI18next)
//   .init({
//     lng: "en",
//     fallbackLng: "en",
//     resources: {
//       en: {
//         translation: require("./locales/en/translation.json")
//       },
//       fr: {
//         translation: require("./locales/fr/translation.json")
//       }
//     }
//   });

// export default i18n;


import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng"
    },
    resources: {
      en: { translation: require("./locales/en/translation.json") },
      fr: { translation: require("./locales/fr/translation.json") }
    }
  });

export default i18n;
